import { ActionService } from 'dashboard-services/services';

export default (() => {

  const ON_CHANGE = 'ON_CHANGE_COLLECTIONS_DATA_LAKE'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_COLLECTIONS_DATA_LAKE'
  const clear = ActionService.makeActionCreator(CLEAR)

  const ON_CHANGE_SUBS_CONFIG = 'ON_CHANGE_SUBS_CONFIG_COLLECTIONS_DATA_LAKE'
  const onChangeSubsConfig = ActionService.makeActionCreator(ON_CHANGE_SUBS_CONFIG, 'value', 'name', 'fieldIndex', 'itemIndex')

  const PROCESS_USER_INPUT_PREFIX = 'PROCESS_USER_INPUT_PREFIX_'
  const PROCESS_METADATA_PREFIX = 'PROCESS_METADATA_PREFIX_'

  return {
    ON_CHANGE,
    onChange,
    CLEAR,
    clear,
    PROCESS_USER_INPUT_PREFIX,
    PROCESS_METADATA_PREFIX,
    ON_CHANGE_SUBS_CONFIG,
    onChangeSubsConfig
  }
})()